import type { FlowDisplayLanguage } from '../displayLanguage';

export const SOUND_EFFECTS = [
  'wake',
  'found',
  'listen',
  'thinking',
] as const;

export type SoundEffect = (typeof SOUND_EFFECTS)[number];

export const DEFAULT_SOUND_EFFECT: SoundEffect = 'wake';

const SOUND_EFFECT_LABELS = {
  wake: { en: 'Start', ja: 'はじまり' },
  found: { en: 'Found', ja: 'みつけた' },
  listen: { en: 'Listen', ja: 'ききとり' },
  thinking: { en: 'Thinking', ja: 'かんがえ中' },
} as const satisfies Record<SoundEffect, Record<FlowDisplayLanguage, string>>;

const SOUND_EFFECT_URLS = {
  wake: '/sounds/sfx_wake.mp3',
  found: '/sounds/sfx_found.mp3',
  listen: '/sounds/sfx_listen.mp3',
  thinking: '/sounds/sfx_thinking.mp3',
} as const satisfies Record<SoundEffect, string>;

export const isSoundEffect = (value: unknown): value is SoundEffect =>
  SOUND_EFFECTS.some((sound) => sound === value);

export const getSoundEffectLabel = (
  sound: SoundEffect,
  language: FlowDisplayLanguage,
): string => SOUND_EFFECT_LABELS[sound][language];

export const getSoundEffectUrl = (sound: SoundEffect): string => SOUND_EFFECT_URLS[sound];
